import { useRef, useEffect } from 'react';
import { useBookingTabs } from './booking-tab-view-context';
import { useBookingsQuery } from './bookings-query-context';

export function useTakeInitialSnapshot() {
  const hasFetchedBookingViews = useBookingsQuery((state) => state.hasFetchedBookingViews);
  const updateSnapshot = useBookingTabs((selector) => selector.updateSnapshot);
  const hasTakenInitialSnapshot = useRef(false);

  useEffect(() => {
    if (hasFetchedBookingViews && !hasTakenInitialSnapshot.current) {
      hasTakenInitialSnapshot.current = true;
      updateSnapshot({ skipUpdateDefaultViews: true });
    }
  }, [hasFetchedBookingViews, updateSnapshot]);
}
